import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import {
    OrderStatuses,
    statusMapping,
} from 'entities/Order/model/consts/orderStatuses';
import { getSelectedOrderStatus } from 'entities/Order/model/selectors/ordersSelectors';

export const useMiddleManAvailability = () => {
    const orderStatus = useSelector(getSelectedOrderStatus);

    const shouldShowHelpButton = useMemo(() => {
        const statusGroups: (keyof typeof statusMapping)[] = [
            OrderStatuses.PROCESSING,
            OrderStatuses.SHIPPED,
            OrderStatuses.INVOICED,
            OrderStatuses.UNABLE_TO_FULFILL,
        ];
        return statusGroups.some((statusGroup) =>
            statusMapping[statusGroup].includes(orderStatus),
        );
    }, [orderStatus]);

    return { shouldShowHelpButton };
};
